import { ChannelAvatar, LockIcon, Sidebar, Text } from '@buffer-mono/popcorn'
import {
  BufferTrackerReact as BufferTracker,
  Product,
} from '@buffer-mono/tracking-plan'

import { UnlockChannelDialog } from '~publish/components/UnlockChannelDialog'
import { getChannelNameForDisplay } from '~publish/helpers/getChannelNameForDisplay'
import { useCommonTrackingProperties } from '~publish/hooks/useCommonTrackingProperties'

import type { MainSidebarChannel } from '../ChannelsSection/useChannels'

import styles from './LockedChannelItem.module.css'

import type { JSX } from 'react'

type LockedChannelItemProps = {
  channel: MainSidebarChannel
}

/**
 * Compact, read-only sidebar row for a locked channel. The row is the trigger
 * for {@link UnlockChannelDialog}: it has no navigation, drag-and-drop, or
 * sub-nav — clicking it only opens the manage-channels dialog.
 */
export function LockedChannelItem({
  channel,
}: LockedChannelItemProps): JSX.Element {
  const commonTrackingProperties = useCommonTrackingProperties()
  const name = getChannelNameForDisplay(channel)

  const handleClick = (): void => {
    BufferTracker.cTAClicked({
      ...commonTrackingProperties,
      product: Product.Publish,
      cta: 'publish-mainSidebar-lockedChannels-1',
      clientName: 'publishWeb',
      upgradePathName: null,
    })
  }

  return (
    <UnlockChannelDialog title={`Unlock ${name}`}>
      <Sidebar.Button
        type="button"
        className={styles.lockedChannelButton}
        aria-label={`${name} (locked channel)`}
        onClick={handleClick}
        prefix={
          <ChannelAvatar
            alt=""
            channel={channel.service}
            src={channel.avatar}
            size="xsmall"
            className={styles.channelAvatar}
            data-testid="channel-avatar"
          />
        }
        suffix={
          <LockIcon size="xsmall" aria-hidden className={styles.lockIcon} />
        }
      >
        <Text className={styles.channelName} translate="no">
          {name}
        </Text>
      </Sidebar.Button>
    </UnlockChannelDialog>
  )
}
